const actionTypes = {
  FetchedCreditCards: 'CREDIT_CARDS_FETCHED',
};

export default actionTypes;
